import { type FunctionComponent } from 'react';

export type NonstockBadgeProps = {
	nonstockCount: number;
	variantCount: number;
	className?: string;
};

export const NonstockBadge: FunctionComponent<NonstockBadgeProps> = ({ nonstockCount, variantCount, className = '' }) => {
	return (
		<div className={`dib ph2 pv1 bg-theme-internal theme-white f6 ${className}`}>
			{nonstockCount < variantCount && <>{nonstockCount}</>} Nonstock
		</div>
	);
};
